import React from 'react';

const AlliedBusinesses: React.FC = () => {
  return (
    <div className="min-h-screen">
      {/* Header Section */}
      <header className="flex items-center justify-center h-40 bg-teal-600 text-white mb-8">
        <div className="container px-4 flex items-center justify-center flex-col text-center">
          <h1 className="text-2xl md:text-3xl font-bold px-2">Vermi Compost & Cow Dung Business</h1>
          <p className="text-teal-200 mt-2 text-sm md:text-base px-2">UAE Market Entry Strategy & Technical Partnerships</p>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-8">
        {/* Introduction Section */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
            <h2 className="text-xl md:text-2xl font-bold text-teal-700 mb-4">Market Opportunity in UAE & Gulf Region</h2>
            <p className="text-gray-700 mb-4 text-sm md:text-base">The UAE and broader Gulf region present significant opportunities for organic fertilizer businesses, particularly vermi compost and cow dung powder products. With increasing focus on sustainable agriculture and organic farming, the market demand is growing steadily.</p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mt-6">
              <div className="bg-amber-50 p-3 md:p-4 rounded-lg">
                <h3 className="font-bold text-amber-700 mb-2 text-sm md:text-base">Market Growth</h3>
                <p className="text-xs md:text-sm">Organic fertilizer market in GCC expected to grow at 8.2% CAGR through 2027</p>
              </div>
              <div className="bg-amber-50 p-3 md:p-4 rounded-lg">
                <h3 className="font-bold text-amber-700 mb-2 text-sm md:text-base">Government Initiatives</h3>
                <p className="text-xs md:text-sm">UAE National Food Security Strategy 2051 promotes sustainable agriculture</p>
              </div>
              <div className="bg-amber-50 p-3 md:p-4 rounded-lg">
                <h3 className="font-bold text-amber-700 mb-2 text-sm md:text-base">Import Dependency</h3>
                <p className="text-xs md:text-sm">Gulf countries import over 80% of agricultural inputs including fertilizers</p>
              </div>
            </div>
          </div>
        </section>

        {/* Technical Specifications Section */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
            <h2 className="text-xl md:text-2xl font-bold text-teal-700 mb-4">Technical Specifications & Quality Standards</h2>

            {/* Vermi Compost Description with Local Background Image */}
            <div className="mb-6 md:my-15 rounded-lg overflow-hidden ">
              <div className=" inset-0   flex items-center justify-center">
                <div className="flex flex-col justify-center text-center  px-3 md:px-4">
                  <h3 className="text-2xl md:text-6xl  uppercase text-green-500 font-bold mb-3 md:mb-4 text-center"> Vermi <span className='text-amber-500'>Compost</span></h3>
                  <p className="text-sm md:text-[17px]  text-gay-500">
                    Vermi compost is a nutrient-rich, organic fertilizer produced through the natural process of
                    vermicomposting - where earthworms break down organic waste matter into a dark, earthy-smelling,
                    crumbly substance packed with beneficial microorganisms and plant-available nutrients.
                  </p><br />
                  <p>
                    Vermicompost has become one of the most demanded organic fertilizers worldwide because it delivers fast, measurable improvements in soil health and crop yield. Modern agriculture is moving away from heavy chemical use, and buyers want solutions that are sustainable, safe, and effective vermicompost checks all those boxes. It enhances microbial activity, boosts nutrient absorption, strengthens root development, and improves overall soil structure, giving farmers better productivity with less input cost. Importers prefer it because it aligns with global organic certification standards, has consistent year-round demand, and is easy to market under private labels. For any client entering or expanding in agricultural inputs, vermicompost is a high-ROI, future-proof product backed by strong global demand and long-term growth potential.
                  </p>
                </div>
              </div>
            </div>



            <div className='flex flex-wrap align-center gap-4 mb-6 justify-center'>
              <img src="/varmicCompose.jpg" alt="Vermicompost Product 1" className='w-32 h-32 md:w-40 md:h-40 lg:w-[500px] lg:h-70 object-cover rounded-lg shadow-md' />
            </div>

            <div className="text-start  p-8 rounded-2xl  max-w-2xl mx-auto mt-10">
              <h2 className="text-2xl font-bold text-green-800 mb-4">
                Vermi Compost Manufacturing
              </h2>
              <p className="text-gray-700 leading-relaxed text-lg">
                We offer reliable, large-scale <b>vermi compost manufacturing</b> to support your brand’s
                growth and sustainability goals.
              </p>

              <div className="mt-6 space-y-3 text-base">
                <p>
                  <span className="font-semibold text-green-700">Consistent Supply Capacity:</span>{' '}
                  <b>Up to 100 metric tons</b> per month to meet your ongoing demand.
                </p>
                <p>
                  <span className="font-semibold text-green-700">White Label Manufacturing:</span>{' '}
                  Customize packaging and labeling with your brand identity.
                </p>
                <p>
                  <span className="font-semibold text-green-700">Minimum Order Quantity (<b>MOQ</b>):</span>{' '}
                  One container (<b>20 metric tons</b>)
                </p>
              </div>
            </div>


            <div className="mb-6">
              <div className="overflow-x-auto">
                <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden">
                  <div className="bg-gradient-to-r from-teal-600 to-teal-700 px-4 py-4">
                    <h3 className="text-lg md:text-xl font-bold text-white text-center">
                      Vermi Compost Quality Analysis
                    </h3>
                    <p className="text-teal-100 text-sm text-center mt-1">
                      Laboratory Test Results vs UAE Standards
                    </p>
                  </div>

                  <div className="overflow-x-auto">
                    <table className="w-full">
                      <thead>
                        <tr className="bg-gradient-to-r from-teal-50 to-green-50">
                          <th className="py-3 px-3 md:px-4 text-left font-bold text-teal-800 text-sm md:text-base border-b border-teal-200">
                            Parameter
                          </th>
                          <th className="py-3 px-3 md:px-4 text-left font-bold text-teal-800 text-sm md:text-base border-b border-teal-200">
                            Test Result
                          </th>
                          <th className="py-3 px-3 md:px-4 text-left font-bold text-teal-800 text-sm md:text-base border-b border-teal-200">
                            UAE Standards
                          </th>
                          <th className="py-3 px-3 md:px-4 text-left font-bold text-teal-800 text-sm md:text-base border-b border-teal-200">
                            Status
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100">
                        {/* pH Row */}
                        <tr className="hover:bg-teal-25 transition-colors duration-200">
                          <td className="py-3 px-3 md:px-4 font-semibold text-gray-800 text-sm">
                            <div className="flex items-center">
                              <div className="w-2 h-2 bg-teal-500 rounded-full mr-2"></div>
                              pH Level
                            </div>
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs font-medium">
                              7.14
                            </span>
                          </td>
                          <td className="py-3 px-3 md:px-4 text-xs md:text-sm text-gray-600">
                            Neutral (6.5-7.5)
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                              ✓ Optimal
                            </span>
                          </td>
                        </tr>

                        {/* Electrical Conductivity */}
                        <tr className="hover:bg-teal-25 transition-colors duration-200">
                          <td className="py-3 px-3 md:px-4 font-semibold text-gray-800 text-sm">
                            <div className="flex items-center">
                              <div className="w-2 h-2 bg-teal-500 rounded-full mr-2"></div>
                              Electrical Conductivity
                            </div>
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs font-medium">
                              1.91 dS/m
                            </span>
                          </td>
                          <td className="py-3 px-3 md:px-4 text-xs md:text-sm text-gray-600">
                            ≤4.0 dS/m (UAE S 5030:2014)
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                              ✓ Compliant
                            </span>
                          </td>
                        </tr>

                        {/* Moisture - Warning */}
                        <tr className="hover:bg-amber-25 transition-colors duration-200">
                          <td className="py-3 px-3 md:px-4 font-semibold text-gray-800 text-sm">
                            <div className="flex items-center">
                              <div className="w-2 h-2 bg-amber-500 rounded-full mr-2"></div>
                              Moisture Content
                            </div>
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="bg-amber-100 text-amber-800 px-2 py-1 rounded-full text-xs font-medium">
                              35.37%
                            </span>
                          </td>
                          <td className="py-3 px-3 md:px-4 text-xs md:text-sm text-gray-600">
                            ≤15-20% (ESMA 1001:2019)
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-amber-100 text-amber-800">
                              ⚠ High
                            </span>
                          </td>
                        </tr>

                        {/* Organic Matter - Excellent */}
                        <tr className="hover:bg-teal-25 transition-colors duration-200">
                          <td className="py-3 px-3 md:px-4 font-semibold text-gray-800 text-sm">
                            <div className="flex items-center">
                              <div className="w-2 h-2 bg-teal-500 rounded-full mr-2"></div>
                              Organic Matter
                            </div>
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="bg-emerald-100 text-emerald-800 px-2 py-1 rounded-full text-xs font-medium">
                              81.72%
                            </span>
                          </td>
                          <td className="py-3 px-3 md:px-4 text-xs md:text-sm text-gray-600">
                            ≥25-30% (ESMA 1001:2019)
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800">
                              ★ Excellent
                            </span>
                          </td>
                        </tr>

                        {/* Macronutrients Section */}
                        <tr className="bg-gray-50">
                          <td colSpan={4} className="py-2 px-3 md:px-4">
                            <span className="text-sm font-bold text-gray-700 uppercase tracking-wide">
                              Macronutrients
                            </span>
                          </td>
                        </tr>

                        {/* Nitrogen */}
                        <tr className="hover:bg-teal-25 transition-colors duration-200">
                          <td className="py-3 px-3 md:px-4 font-medium text-gray-700 text-sm pl-6">
                            Total Nitrogen (N)
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs font-medium">
                              2.82%
                            </span>
                          </td>
                          <td className="py-3 px-3 md:px-4 text-xs md:text-sm text-gray-500">
                            -
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                              Good
                            </span>
                          </td>
                        </tr>

                        {/* Phosphorus */}
                        <tr className="hover:bg-teal-25 transition-colors duration-200">
                          <td className="py-3 px-3 md:px-4 font-medium text-gray-700 text-sm pl-6">
                            Total Phosphorus (P)
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="bg-purple-100 text-purple-800 px-2 py-1 rounded-full text-xs font-medium">
                              6.2%
                            </span>
                          </td>
                          <td className="py-3 px-3 md:px-4 text-xs md:text-sm text-gray-500">
                            -
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                              High
                            </span>
                          </td>
                        </tr>

                        {/* Potassium */}
                        <tr className="hover:bg-teal-25 transition-colors duration-200">
                          <td className="py-3 px-3 md:px-4 font-medium text-gray-700 text-sm pl-6">
                            Total Potassium (K)
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="bg-orange-100 text-orange-800 px-2 py-1 rounded-full text-xs font-medium">
                              1.21%
                            </span>
                          </td>
                          <td className="py-3 px-3 md:px-4 text-xs md:text-sm text-gray-500">
                            -
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
                              Moderate
                            </span>
                          </td>
                        </tr>

                        {/* Micronutrients Section */}
                        <tr className="bg-gray-50">
                          <td colSpan={4} className="py-2 px-3 md:px-4">
                            <span className="text-sm font-bold text-gray-700 uppercase tracking-wide">
                              Micronutrients & Trace Elements
                            </span>
                          </td>
                        </tr>

                        {/* Micronutrient Rows */}
                        {[
                          { parameter: "Total Sodium", value: "<0.01%", color: "gray" },
                          { parameter: "Total Calcium", value: "<0.19%", color: "gray" },
                          { parameter: "Total Magnesium", value: "<0.12%", color: "gray" },
                          { parameter: "Total Sulphur", value: "<0.32%", color: "gray" },
                          { parameter: "Total Copper", value: "<22.6%", color: "gray" },
                          { parameter: "Total Iron", value: "<6314", color: "gray" },
                          { parameter: "Total Manganese", value: "<214", color: "gray" },
                          { parameter: "Total Zinc", value: "<41.3%", color: "gray" },
                          { parameter: "Total Boron", value: "<3.01%", color: "gray" },
                        ].map((item, index) => (
                          <tr key={index} className="hover:bg-gray-50 transition-colors duration-200">
                            <td className="py-2 px-3 md:px-4 text-gray-600 text-sm pl-6">
                              {item.parameter}
                            </td>
                            <td className="py-2 px-3 md:px-4">
                              <span className="bg-gray-100 text-gray-700 px-2 py-1 rounded-full text-xs font-medium">
                                {item.value}
                              </span>
                            </td>
                            <td className="py-2 px-3 md:px-4 text-xs md:text-sm text-gray-400">
                              -
                            </td>
                            <td className="py-2 px-3 md:px-4">
                              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
                                Trace
                              </span>
                            </td>
                          </tr>
                        ))}

                        {/* C/N Ratio */}
                        <tr className="hover:bg-teal-25 transition-colors duration-200 border-t border-gray-200">
                          <td className="py-3 px-3 md:px-4 font-semibold text-gray-800 text-sm">
                            <div className="flex items-center">
                              <div className="w-2 h-2 bg-teal-500 rounded-full mr-2"></div>
                              Carbon/Nitrogen Ratio
                            </div>
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="bg-teal-100 text-teal-800 px-2 py-1 rounded-full text-xs font-medium">
                              16:8:1
                            </span>
                          </td>
                          <td className="py-3 px-3 md:px-4 text-xs md:text-sm text-gray-600">
                            Ideal: 20-30:1
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-teal-100 text-teal-800">
                              ✓ Balanced
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* Summary Footer */}
                  <div className="bg-gradient-to-r from-teal-50 to-green-50 px-4 py-3 border-t border-teal-200">
                    <div className="flex flex-wrap items-center justify-between gap-2">
                      <div className="flex items-center space-x-4">
                        <div className="flex items-center">
                          <div className="w-3 h-3 bg-green-500 rounded-full mr-1"></div>
                          <span className="text-xs text-gray-600">Compliant</span>
                        </div>
                        <div className="flex items-center">
                          <div className="w-3 h-3 bg-amber-500 rounded-full mr-1"></div>
                          <span className="text-xs text-gray-600">Needs Attention</span>
                        </div>
                        <div className="flex items-center">
                          <div className="w-3 h-3 bg-emerald-500 rounded-full mr-1"></div>
                          <span className="text-xs text-gray-600">Excellent</span>
                        </div>
                      </div>
                      <div className="text-xs text-teal-700 font-medium">
                        Last Updated: {new Date().toLocaleDateString()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>



            <div className="mb-6 md:my-15 rounded-lg overflow-hidden ">
              <div className=" inset-0   flex items-center justify-center">
                <div className="text-center  px-3 md:px-4">
                  <h3 className="text-2xl md:text-6xl  uppercase text-green-500 font-bold mb-3 md:mb-4"> Cow Dung  <span className='text-amber-500'>Powder</span></h3>
                  <p className="text-sm md:text-[17px]  text-gay-500">
                    Cow dung powder is a completely organic, natural fertilizer made from dried and powdered cow dung.
                    It is an excellent source of organic matter and nutrients for plants, rich in nitrogen, phosphorus,
                    potassium, and beneficial microorganisms.
                  </p>
                  <br />
                  <p>
                    Cow dung powder is experiencing a massive resurgence in both domestic and international markets due to the global push for organic, carbon-rich soil amendments. Farmers and distributors are choosing cow dung powder because it naturally increases soil fertility, improves moisture retention, and restores depleted land something chemical fertilizers simply can’t do. GCC countries, Europe, and Africa are importing large volumes to meet organic farming guidelines and sustainability targets, making this product one of the most stable and repeat-demand items in the agricultural sector. For businesses, cow dung powder offers dependable market traction, low production risk, and excellent branding opportunities through white-label manufacturing. It’s the right product at the right time for clients aiming to tap into the booming organic fertilizer market.
                  </p>
                </div>
              </div>
            </div>

            <div className='flex flex-wrap align-center gap-4 mb-6 justify-center'>
              <img src="/DungPowder.jpg" alt="Vermicompost Product 1" className='w-32 h-32 md:w-40 md:h-40 lg:w-[500px] lg:h-80 object-cover rounded-lg shadow-md' />
            </div>


<div className="text-start p-8 rounded-2xl max-w-2xl mx-auto mt-10 ">
  <h2 className="text-2xl font-bold text-yellow-800 mb-4">
    Cow Dung Powder Manufacturing
  </h2>
  <p className="text-gray-700 leading-relaxed text-lg">
    We offer reliable, large-scale <b>cow dung powder manufacturing</b> to support your brand’s
    growth and sustainability goals.
  </p>

  <div className="mt-6 space-y-3 text-base">
    <p>
      <span className="font-semibold text-yellow-700">Consistent Supply Capacity:</span>{' '}
      <b>Up to 50 metric tons</b> per month to meet your ongoing demand.
    </p>
    <p>
      <span className="font-semibold text-yellow-700">White Label Manufacturing:</span>{' '}
      Customize packaging and labeling with your brand identity.
    </p>
    <p>
      <span className="font-semibold text-yellow-700">Minimum Order Quantity (<b>MOQ</b>):</span>{' '}
      One container (<b>20 metric tons</b>)
    </p>
  </div>
</div>

            <div>
              <div className="overflow-x-auto">
                <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden">
                  <div className="bg-gradient-to-r from-amber-600 to-amber-700 px-4 py-4">
                    <h3 className="text-lg md:text-xl font-bold text-white text-center">
                      Cow Dung Powder Specifications
                    </h3>
                    <p className="text-amber-100 text-sm text-center mt-1">
                      Quality Standards & UAE Compliance
                    </p>
                  </div>

                  <div className="overflow-x-auto">
                    <table className="w-full">
                      <thead>
                        <tr className="bg-gradient-to-r from-amber-50 to-orange-50">
                          <th className="py-3 px-3 md:px-4 text-left font-bold text-amber-800 text-sm md:text-base border-b border-amber-200">
                            Parameter
                          </th>
                          <th className="py-3 px-3 md:px-4 text-left font-bold text-amber-800 text-sm md:text-base border-b border-amber-200">
                            Specification
                          </th>
                          <th className="py-3 px-3 md:px-4 text-left font-bold text-amber-800 text-sm md:text-base border-b border-amber-200">
                            UAE Standards
                          </th>
                          <th className="py-3 px-3 md:px-4 text-left font-bold text-amber-800 text-sm md:text-base border-b border-amber-200">
                            Compliance
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100">
                        {/* Organic Carbon */}
                        <tr className="hover:bg-amber-25 transition-colors duration-200">
                          <td className="py-3 px-3 md:px-4 font-semibold text-gray-800 text-sm">
                            <div className="flex items-center">
                              <div className="w-2 h-2 bg-amber-500 rounded-full mr-2"></div>
                              Organic Carbon
                            </div>
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="bg-amber-100 text-amber-800 px-3 py-1 rounded-full text-xs font-medium">
                              Min. 12-15%
                            </span>
                          </td>
                          <td className="py-3 px-3 md:px-4 text-xs md:text-sm text-gray-600">
                            ESMA Standard 1002:2020
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                              ✓ Standard
                            </span>
                          </td>
                        </tr>

                        {/* Moisture Content */}
                        <tr className="hover:bg-amber-25 transition-colors duration-200">
                          <td className="py-3 px-3 md:px-4 font-semibold text-gray-800 text-sm">
                            <div className="flex items-center">
                              <div className="w-2 h-2 bg-amber-500 rounded-full mr-2"></div>
                              Moisture Content
                            </div>
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs font-medium">
                              Max. 10-12%
                            </span>
                          </td>
                          <td className="py-3 px-3 md:px-4 text-xs md:text-sm text-gray-600">
                            ESMA Standard 1002:2020
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                              ✓ Compliant
                            </span>
                          </td>
                        </tr>

                        {/* Nitrogen Content */}
                        <tr className="hover:bg-amber-25 transition-colors duration-200">
                          <td className="py-3 px-3 md:px-4 font-semibold text-gray-800 text-sm">
                            <div className="flex items-center">
                              <div className="w-2 h-2 bg-amber-500 rounded-full mr-2"></div>
                              Nitrogen Content
                            </div>
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-medium">
                              Min. 1.0-1.5%
                            </span>
                          </td>
                          <td className="py-3 px-3 md:px-4 text-xs md:text-sm text-gray-600">
                            UAE.S 5031:2015
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                              ✓ Certified
                            </span>
                          </td>
                        </tr>

                        {/* Pathogen Free */}
                        <tr className="hover:bg-amber-25 transition-colors duration-200">
                          <td className="py-3 px-3 md:px-4 font-semibold text-gray-800 text-sm">
                            <div className="flex items-center">
                              <div className="w-2 h-2 bg-amber-500 rounded-full mr-2"></div>
                              Pathogen Free
                            </div>
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-xs font-medium">
                              E.coli & Salmonella negative
                            </span>
                          </td>
                          <td className="py-3 px-3 md:px-4 text-xs md:text-sm text-gray-600">
                            GCC Standardization
                          </td>
                          <td className="py-3 px-3 md:px-4">
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800">
                              ★ Essential
                            </span>
                          </td>
                        </tr>

                        {/* Additional Specifications */}
                        <tr className="bg-amber-50">
                          <td colSpan={4} className="py-2 px-3 md:px-4">
                            <span className="text-sm font-bold text-amber-700 uppercase tracking-wide">
                              Additional Quality Parameters
                            </span>
                          </td>
                        </tr>

                        {/* pH Level */}
                        <tr className="hover:bg-amber-25 transition-colors duration-200">
                          <td className="py-2 px-3 md:px-4 font-medium text-gray-700 text-sm pl-6">
                            pH Level
                          </td>
                          <td className="py-2 px-3 md:px-4">
                            <span className="bg-purple-100 text-purple-800 px-2 py-1 rounded-full text-xs font-medium">
                              6.5 - 7.5
                            </span>
                          </td>
                          <td className="py-2 px-3 md:px-4 text-xs md:text-sm text-gray-500">
                            Optimal Range
                          </td>
                          <td className="py-2 px-3 md:px-4">
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                              Balanced
                            </span>
                          </td>
                        </tr>

                        {/* Bulk Density */}
                        <tr className="hover:bg-amber-25 transition-colors duration-200">
                          <td className="py-2 px-3 md:px-4 font-medium text-gray-700 text-sm pl-6">
                            Bulk Density
                          </td>
                          <td className="py-2 px-3 md:px-4">
                            <span className="bg-indigo-100 text-indigo-800 px-2 py-1 rounded-full text-xs font-medium">
                              0.6 - 0.8 g/cm³
                            </span>
                          </td>
                          <td className="py-2 px-3 md:px-4 text-xs md:text-sm text-gray-500">
                            Industry Standard
                          </td>
                          <td className="py-2 px-3 md:px-4">
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                              Normal
                            </span>
                          </td>
                        </tr>

                        {/* Particle Size */}
                        <tr className="hover:bg-amber-25 transition-colors duration-200">
                          <td className="py-2 px-3 md:px-4 font-medium text-gray-700 text-sm pl-6">
                            Particle Size
                          </td>
                          <td className="py-2 px-3 md:px-4">
                            <span className="bg-teal-100 text-teal-800 px-2 py-1 rounded-full text-xs font-medium">
                              &lt; 2mm
                            </span>
                          </td>
                          <td className="py-2 px-3 md:px-4 text-xs md:text-sm text-gray-500">
                            Fine Powder
                          </td>
                          <td className="py-2 px-3 md:px-4">
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-teal-100 text-teal-800">
                              Optimal
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* Summary Footer */}
                  <div className="bg-gradient-to-r from-amber-50 to-orange-50 px-4 py-3 border-t border-amber-200">
                    <div className="flex flex-wrap items-center justify-between gap-2">
                      <div className="flex items-center space-x-4">
                        <div className="flex items-center">
                          <div className="w-3 h-3 bg-green-500 rounded-full mr-1"></div>
                          <span className="text-xs text-gray-600">Compliant</span>
                        </div>
                        <div className="flex items-center">
                          <div className="w-3 h-3 bg-amber-500 rounded-full mr-1"></div>
                          <span className="text-xs text-gray-600">Standard</span>
                        </div>
                        <div className="flex items-center">
                          <div className="w-3 h-3 bg-emerald-500 rounded-full mr-1"></div>
                          <span className="text-xs text-gray-600">Essential</span>
                        </div>
                      </div>
                      <div className="text-xs text-amber-700 font-medium">
                        Quality Certified • GCC Standards
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Business Partnerships Section */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
            <h2 className="text-xl md:text-2xl font-bold text-teal-700 mb-4">Business TIE-UPS & Strategic Partnerships</h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
              <div className="border-l-4 border-amber-500 pl-3 md:pl-4">
                <h3 className="text-lg md:text-xl font-semibold text-gray-800 mb-2">Local Distribution Partnerships</h3>
                <ul className="list-disc pl-4 md:pl-5 text-gray-700 text-sm md:text-base">
                  <li>Agricultural cooperatives in Al Ain and Ras Al Khaimah</li>
                  <li>Specialty garden centers across UAE</li>
                  <li>Hydroponics suppliers in Dubai and Abu Dhabi</li>
                  <li>Landscaping companies serving commercial projects</li>
                </ul>
              </div>

              <div className="border-l-4 border-amber-500 pl-3 md:pl-4">
                <h3 className="text-lg md:text-xl font-semibold text-gray-800 mb-2">Manufacturing & Processing</h3>
                <ul className="list-disc pl-4 md:pl-5 text-gray-700 text-sm md:text-base">
                  <li>Joint ventures with existing fertilizer producers</li>
                  <li>Technology transfer agreements for vermicomposting</li>
                  <li>Licensing of specialized processing equipment</li>
                  <li>Quality control laboratory partnerships</li>
                </ul>
              </div>

              <div className="border-l-4 border-amber-500 pl-3 md:pl-4">
                <h3 className="text-lg md:text-xl font-semibold text-gray-800 mb-2">Export & Logistics</h3>
                <ul className="list-disc pl-4 md:pl-5 text-gray-700 text-sm md:text-base">
                  <li>Partnerships with freight forwarders</li>
                  <li>Cold chain logistics for temperature-sensitive products</li>
                  <li>Customs clearance specialists for GCC markets</li>
                  <li>Warehousing solutions in Jebel Ali Free Zone</li>
                </ul>
              </div>

              <div className="border-l-4 border-amber-500 pl-3 md:pl-4">
                <h3 className="text-lg md:text-xl font-semibold text-gray-800 mb-2">Research & Development</h3>
                <ul className="list-disc pl-4 md:pl-5 text-gray-700 text-sm md:text-base">
                  <li>Collaboration with UAE University Agriculture Department</li>
                  <li>Partnerships with International Center for Biosaline Agriculture</li>
                  <li>Joint research on soil amendment for arid conditions</li>
                  <li>Product development for date palm cultivation</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Buyer Identification Section */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
            <h2 className="text-xl md:text-2xl font-bold text-teal-700 mb-4">Target Buyer Identification</h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
              <div className="bg-amber-50 p-3 md:p-4 rounded-lg">
                <div className="flex items-center mb-2 md:mb-3">
                  <div className="text-amber-600 text-lg md:text-xl mr-2 md:mr-3">🚜</div>
                  <h3 className="font-bold text-amber-700 text-sm md:text-base">Commercial Farms</h3>
                </div>
                <ul className="text-xs md:text-sm text-gray-700 list-disc pl-4 md:pl-5">
                  <li>Al Dahra Agricultural Company</li>
                  <li>Emirates Bio Farm</li>
                  <li>UAE's large-scale vegetable producers</li>
                  <li>Date palm plantations</li>
                </ul>
              </div>

              <div className="bg-amber-50 p-3 md:p-4 rounded-lg">
                <div className="flex items-center mb-2 md:mb-3">
                  <div className="text-amber-600 text-lg md:text-xl mr-2 md:mr-3">🌱</div>
                  <h3 className="font-bold text-amber-700 text-sm md:text-base">Nurseries & Garden Centers</h3>
                </div>
                <ul className="text-xs md:text-sm text-gray-700 list-disc pl-4 md:pl-5">
                  <li>Dubai Garden Centre</li>
                  <li>Plant Souq</li>
                  <li>Al Awir plant nurseries</li>
                  <li>Specialty organic suppliers</li>
                </ul>
              </div>

              <div className="bg-amber-50 p-3 md:p-4 rounded-lg">
                <div className="flex items-center mb-2 md:mb-3">
                  <div className="text-amber-600 text-lg md:text-xl mr-2 md:mr-3">🏠</div>
                  <h3 className="font-bold text-amber-700 text-sm md:text-base">Landscaping Companies</h3>
                </div>
                <ul className="text-xs md:text-sm text-gray-700 list-disc pl-4 md:pl-5">
                  <li>Companies serving luxury residential projects</li>
                  <li>Golf course maintenance providers</li>
                  <li>Municipal park contractors</li>
                  <li>Hotel landscaping services</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Real Estate Support Section */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
            <h2 className="text-xl md:text-2xl font-bold text-teal-700 mb-4">Real Estate & Infrastructure Support</h2>

            <div className="mb-6">
              <h3 className="text-lg md:text-xl font-semibold text-gray-800 mb-3">Strategic Location Analysis</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                <div className="border rounded-lg p-3 md:p-4">
                  <h4 className="font-bold text-teal-700 mb-2 text-sm md:text-base">Al Ain Region</h4>
                  <p className="text-xs md:text-sm text-gray-700">Known as the garden city of UAE, with established agricultural sector and lower land costs compared to coastal cities.</p>
                  <div className="mt-2 flex flex-wrap gap-1">
                    <span className="bg-amber-100 text-amber-800 text-xs px-2 py-1 rounded">Agricultural Land Available</span>
                    <span className="bg-amber-100 text-amber-800 text-xs px-2 py-1 rounded">Proximity to Farms</span>
                  </div>
                </div>

                <div className="border rounded-lg p-3 md:p-4">
                  <h4 className="font-bold text-teal-700 mb-2 text-sm md:text-base">Ras Al Khaimah</h4>
                  <p className="text-xs md:text-sm text-gray-700">Growing agricultural hub with government incentives for agribusiness and established export infrastructure.</p>
                  <div className="mt-2 flex flex-wrap gap-1">
                    <span className="bg-amber-100 text-amber-800 text-xs px-2 py-1 rounded">Free Zone Benefits</span>
                    <span className="bg-amber-100 text-amber-800 text-xs px-2 py-1 rounded">Port Access</span>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-lg md:text-xl font-semibold text-gray-800 mb-3">Property Acquisition Strategy</h3>
              <div className="bg-gray-50 p-3 md:p-4 rounded-lg">
                <div className="flex items-start mb-3 md:mb-4">
                  <div className="bg-teal-100 p-2 rounded-full mr-2 md:mr-3 flex-shrink-0">
                    <div className="text-teal-600">🏭</div>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800 text-sm md:text-base">Processing Facility Requirements</h4>
                    <p className="text-xs md:text-sm text-gray-700 mt-1">Minimum 5,000 sq. ft. covered area with adequate ventilation, water supply, and waste management systems. Preference for locations with agricultural zoning.</p>
                  </div>
                </div>

                <div className="flex items-start mb-3 md:mb-4">
                  <div className="bg-teal-100 p-2 rounded-full mr-2 md:mr-3 flex-shrink-0">
                    <div className="text-teal-600">📦</div>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800 text-sm md:text-base">Storage & Warehousing</h4>
                    <p className="text-xs md:text-sm text-gray-700 mt-1">Climate-controlled storage facilities to maintain product quality. Strategic locations near major highways for distribution efficiency.</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="bg-teal-100 p-2 rounded-full mr-2 md:mr-3 flex-shrink-0">
                    <div className="text-teal-600">🚚</div>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800 text-sm md:text-base">Logistics Considerations</h4>
                    <p className="text-xs md:text-sm text-gray-700 mt-1">Proximity to ports (Jebel Ali, Khalifa Port) for export operations. Access to Dubai-Al Ain Road (E66) and Emirates Road (E611) for domestic distribution.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Market Entry Steps */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
            <h2 className="text-xl md:text-2xl font-bold text-teal-700 mb-4">Market Entry Implementation Steps</h2>

            <div className="relative">
              {/* Vertical line */}
              <div className="absolute left-4 top-0 h-full w-0.5 bg-amber-200 hidden md:block"></div>

              {/* Steps */}
              <div className="relative flex items-start mb-6 md:mb-8">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-teal-600 flex items-center justify-center text-white font-bold text-sm">1</div>
                <div className="ml-4 md:ml-6">
                  <h3 className="font-bold text-gray-800 text-sm md:text-base">Business Registration & Licensing</h3>
                  <p className="text-gray-700 mt-1 text-xs md:text-sm">Register with Department of Economic Development (DED) or appropriate free zone authority. Obtain necessary trade licenses and environmental permits.</p>
                </div>
              </div>

              <div className="relative flex items-start mb-6 md:mb-8">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-teal-600 flex items-center justify-center text-white font-bold text-sm">2</div>
                <div className="ml-4 md:ml-6">
                  <h3 className="font-bold text-gray-800 text-sm md:text-base">Product Certification</h3>
                  <p className="text-gray-700 mt-1 text-xs md:text-sm">Secure ESMA (Emirates Authority for Standardization and Metrology) certification for all products. Obtain organic certification if targeting premium segments.</p>
                </div>
              </div>

              <div className="relative flex items-start mb-6 md:mb-8">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-teal-600 flex items-center justify-center text-white font-bold text-sm">3</div>
                <div className="ml-4 md:ml-6">
                  <h3 className="font-bold text-gray-800 text-sm md:text-base">Facility Establishment</h3>
                  <p className="text-gray-700 mt-1 text-xs md:text-sm">Secure appropriate real estate for manufacturing and storage. Implement quality control systems and processing equipment.</p>
                </div>
              </div>

              <div className="relative flex items-start mb-6 md:mb-8">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-teal-600 flex items-center justify-center text-white font-bold text-sm">4</div>
                <div className="ml-4 md:ml-6">
                  <h3 className="font-bold text-gray-800 text-sm md:text-base">Supply Chain Development</h3>
                  <p className="text-gray-700 mt-1 text-xs md:text-sm">Establish reliable raw material supply chains. Develop distribution networks and logistics partnerships.</p>
                </div>
              </div>

              <div className="relative flex items-start">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-teal-600 flex items-center justify-center text-white font-bold text-sm">5</div>
                <div className="ml-4 md:ml-6">
                  <h3 className="font-bold text-gray-800 text-sm md:text-base">Market Penetration</h3>
                  <p className="text-gray-700 mt-1 text-xs md:text-sm">Implement targeted marketing to identified buyer segments. Participate in agricultural exhibitions and trade events.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default AlliedBusinesses;